import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-permissions',
  templateUrl: './permissions.component.html',
  styleUrls: ['./permissions.component.scss']
})
export class PermissionsComponent {
  constructor(private router: Router) {
    
  }
  goToHome() {
    this.router.navigate(['/home'],{
      queryParamsHandling: 'merge',
    })
    // this.router.navigate(['/home'])
  }
}
